__turbopack_context__.v({
  "className": "honey_dbf8e12c-module__3Y33_a__className",
  "variable": "honey_dbf8e12c-module__3Y33_a__variable",
});
